/**
 * 快速填寫入會申請 Mock 工具
 * 使用方法: 在組件中 import 並呼叫 ApplicationMock(this.form)
 */

/**
 * 產生隨機身分證字號 (符合格式 L123456789)
 */
const generateRandomId = () => {
  const letters = 'ABCDEFGHJKLMNPQRSTUVXYWZIO';
  const firstLetter = letters.charAt(Math.floor(Math.random() * letters.length));
  const firstDigit = Math.floor(Math.random() * 2) + 1; // 1:男, 2:女
  let id = firstLetter + firstDigit;
  for (let i = 0; i < 8; i += 1) {
    id += Math.floor(Math.random() * 10);
  }
  return id;
};

/**
 * 將 Base64 轉換為 File 物件
 */
const base64ToFile = (base64, filename) => {
  const arr = base64.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  const n = bstr.length;
  const u8arr = new Uint8Array(n);
  for (let i = 0; i < n; i += 1) {
    u8arr[i] = bstr.charCodeAt(i);
  }
  return new File([u8arr], filename, { type: mime });
};

// 1x1 像素的純色圖 (確保 Base64 格式正確)
const FAKE_PNG = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==';

/* eslint-disable no-param-reassign */
/**
 * 深度合併資料到表單
 */
const mergeDeep = (target, source) => {
  Object.keys(source).forEach((key) => {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key]) && !(source[key] instanceof File)) {
      if (!target[key]) target[key] = {};
      mergeDeep(target[key], source[key]);
    } else {
      target[key] = source[key];
    }
  });
};
/* eslint-enable no-param-reassign */

const ApplicationMock = (form) => {
  if (process.env.NODE_ENV !== 'development') return;

  const mockData = {
    realname: `測試人員${Math.floor(Math.random() * 100)}`,
    gender: Math.random() > 0.5 ? 'm' : 'f', // 配合 ApplicationIndex.vue 的小寫值
    birthday: '1990-01-01',
    is_permanent: Math.random() > 0.5 ? 1 : 0,
    id_number: generateRandomId(),
    phone: `09${Math.floor(10000000 + Math.random() * 90000000)}`,
    email: 'test@example.com',
    city: '台北市',
    area: '中正區',
    zipcode: '100',
    addr: '測試路一段1號',
    jobs: {
      department: '家醫科',
      hospital_name: '測試醫院',
      hospital_city: '台北市',
      hospital_area: '大安區',
      hospital_zipcode: '106',
      hospital_addr: '信義路三段100號',
    },
    school: {
      name: '國立台灣大學',
      graduation: '104',
    },
    memo: {
      line_id: 'test_line',
      office_tel: '0223456789',
      resume: '這是一份測試簡歷內容。包含自動產生的隨機資料與 FAKE 圖片。',
      agreeToFollow: true,
      license_to_date: '0-10年',
    },
    files: {
      id_1: { title: 'id_front.png', file: base64ToFile(FAKE_PNG, 'id_front.png') },
      id_2: { title: 'id_back.png', file: base64ToFile(FAKE_PNG, 'id_back.png') },
      license_1: { title: 'license_front.png', file: base64ToFile(FAKE_PNG, 'license_front.png') },
      license_2: { title: 'license_back.png', file: base64ToFile(FAKE_PNG, 'license_back.png') },
      photo: { title: 'photo.png', file: base64ToFile(FAKE_PNG, 'photo.png') },
    },
  };

  mergeDeep(form, mockData);
};

export default ApplicationMock;
